import Vue from 'vue'
import axios from 'axios'
import VueAxios from 'vue-axios'
import VueRouter from 'vue-router'
import Vuetify from 'vuetify'
import VeeValidate from 'vee-validate'
import VueScrollactive from 'vue-scrollactive'
import VueSweetalert2 from 'vue-sweetalert2'
import VideoBg from 'vue-videobg'
import App from './App'
import { routerRoutes } from './routes'
import 'vuetify/dist/vuetify.min.css'
Vue.config.productionTip = false

Vue.use(Vuetify)
Vue.use(VueAxios, axios)
Vue.use(VueRouter)
Vue.use(VueScrollactive)
Vue.use(VueSweetalert2)
Vue.component('video-bg', VideoBg)

const veeConfig = {
  fieldsBagName: 'flags',
  delay: 100,
  events: 'input|blur',
  classes: true,
  classNames: {
    touched: 'input-group--touched', // the control has been blurred
    // untouched: 'untouched', // the control hasn't been blurred
    valid: 'input-group--success', // model is valid
    invalid: 'input-group--error', // model is invalid
    // pristine: 'pristine', // control has not been interacted with
    dirty: 'input-group--dirty' // control has been interacted with
  }
}
Vue.use(VeeValidate, veeConfig)

export default {Vue}

axios.defaults.baseURL = 'https://api.lcrplus.com/v1/'

Vue.component('app', App)
const routes = routerRoutes

const router = new VueRouter({
  // base: process.env.environment === 'development' ? '/' : '/subdir/app/',
  mode: 'history',
  linkActiveClass: 'active',
  routes,
  scrollBehavior (to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    } else {
      return { x: 0, y: 0 }
    }
  }
})

/* eslint-disable no-new */
// eslint-disable-next-line
new Vue({
  el: '#app',
  render: h => h(App),
  router
})



// WEBPACK FOOTER //
// ./src/main.js